export default ({ data: { category, products } }, { linkTo, t }) => {
  const categoryProps = {};

  const path = linkTo('productCompare', { category, products });
  if (category) {
    categoryProps.thumbnail = category.logo;
    categoryProps.breadcrumb = category.path.concat([
      {
        name: t('category', 'product-compare.breadcrumb'),
        pathName: path,
      },
    ]);
  }
  return {
    ...categoryProps,
    noIndex: true,
    title: category
      ? t('meta', 'product-compare.title', {
          categoryName: category.name,
        })
      : t('meta', 'product-compare.title-fallback'),
  };
};
